import './SocialLogin.css';
import { useGoogleLogin } from '@react-oauth/google';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';

const BACKEND_URL = 'https://backend-569133653378.asia-southeast2.run.app';
const REDIRECT_URI = 'https://autoforward.brili.tech/google';
const REQUIRED_SCOPES = [
	'https://www.googleapis.com/auth/gmail.modify',
	'https://www.googleapis.com/auth/gmail.settings.basic',
];

function Google() {
	const [loading, setLoading] = React.useState(false);
	const navigate = useNavigate();
	const login = useGoogleLogin({
		onSuccess: async (codeResp) => {
			setLoading(true);
			const getTokenResp = await fetch(
				`${BACKEND_URL}/auth/login/google?code=${codeResp.code}`,
			);
			if (!getTokenResp.ok) {
				navigate('/error', {
					state: { message: await getTokenResp.text(), type: 'google' },
				});
				return;
			}
			const { tokens, message, code, email } = await getTokenResp.json();
			if (code === 1) {
				// User has been onboarded before, resync their filter
				const resyncResp = await fetch(`${BACKEND_URL}/admin/resyncFilter/`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Basic YnJpbGl0ZWNoLWFkbWluOlc5QXFPZTc4amE='
					},
					body: JSON.stringify({
						email: email
					})
				});
				
				setLoading(false);
				if (resyncResp.ok) {
					navigate('/success', {
						state: { message: 'Gmail filter resynced successfully', type: 'google' },
					});
				} else {
					navigate('/error', {
						state: { message: 'Failed to resync Gmail filter', type: 'google' },
					});
				}
				return;
			}
			if (!tokens) {
				navigate('/error', { state: { message, type: 'google' } });
				return;
			}
			const createFilterResp = await fetch(`${BACKEND_URL}/api/filters/`, {
				method: 'POST',
				headers: {
					Authorization: `Bearer ${tokens.access_token}`,
				},
			});
			if (createFilterResp.ok) {
				navigate('/success', {
					state: { message: 'Gmail integrated successfully', type: 'google' },
				});
			}
			setLoading(false);
		},
		flow: 'auth-code',
		scope: REQUIRED_SCOPES.join(' '),
		redirect_uri: REDIRECT_URI,
	});

	return (
		<div>
			<div className="custom-card">
				<div className="custom-card-header-row">
					<h1 className="page-title">Welcome to Brilitech</h1>
					<img src="/brilitech-logo.png" alt="logo" className="logo-img" />
				</div>
				<div className="custom-card-header">
					<div className="custom-card-title">Gmail Integration</div>
				</div>
				<div className="custom-card-content">
					<p style={{ textAlign: 'center', marginBottom: 24 }}>
						To begin using our services, please connect your Gmail account.
					</p>
					<div className="info-box">
						<div className="info-box-title">What this integration does:</div>
						<ul>
							<li>
								Creates email filters to identify trade confirmation emails from
								your brokerage platform
							</li>
							<li>
								Labels and forwards only relevant brokerage emails to our secure
								system
							</li>
							<li>
								Enables automated monitoring and analysis of your trading
								activity
							</li>
						</ul>
					</div>
					<div className="privacy-box">
						<div className="privacy-title">Privacy Assurance</div>
						<div className="privacy-text">
							Only emails from verified brokerage platforms will be processed.
							Your personal correspondence remains private and will not be
							accessed or forwarded.
						</div>
					</div>
					<p style={{ textAlign: 'center', marginBottom: 24 }}>
						By clicking the button below, you consent to these permissions and
						agree to our terms of service.
					</p>
					<button onClick={login} className="connect-btn" disabled={loading}>
						{loading ? 'Connecting...' : 'Connect Gmail'}
						<span
							style={{
								marginLeft: 8,
								display: 'inline-flex',
								alignItems: 'center',
							}}
						>
							<svg
								width="20"
								height="20"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
								strokeWidth="2"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									d="M17 8l4 4m0 0l-4 4m4-4H3"
								/>
							</svg>
						</span>
					</button>
				</div>
			</div>
			<Footer />
		</div>
	);
}

export default Google;
